import React, { Component } from 'react';
import moment from 'moment';
import http from '../../../utils/http';
import { toast } from 'react-toastify';
import classes from './docFwb.module.css';
import docStyle from '../docsStream/docs.module.css';
import { Box, Dialog, Stack, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { CustomDialogContent, CustomDialogTitle } from '../../../custom/components';
import { CloseIconBtn } from '../../../custom/constants';
import { Group, Panel, Separator } from 'react-resizable-panels';
import DocViewer from '../docsStream/DocViewer';
import DocStreamsList from '../docsStream/DocStreamList';
import AddDocModal from '../docsStream/AddDocModal';
import AwbModal from '../docsStream/AwbModal';
import ConfirmModalContainer from '../common/confirmModal/ConfirmModalContainer';
import FwbData from './sections/FwbData';
import { hydrateFormDataFromFwb } from './sections/fwbParser';
import cookies from 'utils/cookies';
import events from '../../../utils/evemts';
import dayjs from 'dayjs';
import { dateToUTC, getLocatDate } from 'utils/converter';
import { connect } from 'react-redux';
import { setDeleteAction } from 'store/actions/deleteAction';
import threeSectionIcon from 'assets/images/actionIcons/section3.svg';
import twoSectionIcon from 'assets/images/actionIcons/section2.svg';

export class DocFwb extends Component {
  constructor(props) {
    super(props);
    let savedSearchOptions = null;
    try {
      const stored = sessionStorage.getItem('docsStream_searchOptions');
      if (stored) {
        savedSearchOptions = JSON.parse(stored);
      }
    } catch (e) {
      console.error(e);
    }

    this.state = {
      activeView: 'FWB',
      doc: null,
      docId: 0,
      docs: [],
      data: [],
      docData: [],
      searchOptions: savedSearchOptions || {
        start: getLocatDate('DD MMM YYYY'),
        end: getLocatDate('DD MMM YYYY'),
        verified: false,
        identity: 'all',
        awb: '',
      },
      stackDocs: [],
      processingDoc: {},
      modal: false,
      exModal: false,
      exData: {},
      docFields: {},
      docErrors: {},
      attachment: false,
      anchorEl: null,
      isEditable: false,
      value: 'pending',
      fileType: 'third',
      addDocType: 'AWB',
      attachTo: 'OTHER',
      fwbData: null,
      fwbLines: [],
      fwbRawText: '',
      fwbVersions: [],
      selectedFwbVersion: 1,
      fwbWarnings: [],
      fwbTactIssues: [],
      fwbErrors: [],
      hasTactBreach: false,
      fwbValidation: null,
      isFwbLoading: false,
      isGeneratingFwb: false,
      fwbGenerated: false,
      lastGeneratedDate: '',
      airlines: [],
      stations: [],
      isCompactLayout: window.innerWidth <= 991,
      isSmallScreen: window.innerWidth <= 600,
      isDocumentViewerOpen: false,
      isGroupDocumentListHidden: false,
    };
    this.station_code = cookies.get('station_code') || null;
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleWindowResize);
    this.fetchDocs(false);
    this.fetchStackDocs();
    this.fetchDocData();
    this.fetchReferenceData();

    this.eventSource = events('docs', 'stream');
    this.eventSource.onmessage = ({ type, data }) => {
      if (type === 'message') {
        const msg = JSON.parse(data || '{}');
        this.handleEvent(msg);
      }
    };

    this.eventSource2 = events('docs', 'stack');
    this.eventSource2.onmessage = ({ type, data }) => {
      if (type === 'message') {
        const msg = JSON.parse(data || '{}');
        this.handleStackEvent(msg);
      }
    };
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowResize);
    if (this.eventSource) {
      this.eventSource.close();
    }
    if (this.eventSource2) {
      this.eventSource2.close();
    }
  }

  handleWindowResize = () => {
    const isCompactLayout = window.innerWidth <= 991;
    const isSmallScreen = window.innerWidth <= 600;
    this.setState((state) => (
      state.isCompactLayout === isCompactLayout && state.isSmallScreen === isSmallScreen
        ? null
        : {
          isCompactLayout,
          isSmallScreen,
          isDocumentViewerOpen: isCompactLayout && state.isDocumentViewerOpen,
        }
    ));
  };

  toggleDocumentList = (isHidden) => {
    this.setState((prevState) => ({ isGroupDocumentListHidden: typeof isHidden === 'boolean' ? isHidden : !prevState.isGroupDocumentListHidden }));
  };

  openDocumentViewer = () => {
    this.setState({ isDocumentViewerOpen: true });
  };

  closeDocumentViewer = () => {
    this.setState({ isDocumentViewerOpen: false });
  };

  componentDidUpdate(prevProps) {
    const prevId = prevProps.match?.params?.id;
    const currentId = this.props.match?.params?.id;
    if (currentId && currentId !== prevId) {
      const doc =
        this.state.data.find((d) => String(d.id) === String(currentId)) ||
        this.state.docs.find((d) => String(d.id) === String(currentId));
      if (doc) {
        this.selectDoc(doc);
      } else {
        this.fetchDocData();
      }
    }
  }

  fetchReferenceData = () => {
    http
      .get('/airline?active=true')
      .then((res) => {
        if (res?.data?.data) {
          const codes = res.data.data.map((a) => a.code).filter(Boolean);
          this.setState({ airlines: codes });
        }
      })
      .catch((e) => console.error(e));

    http
      .get('/station')
      .then((res) => {
        if (res?.data?.data) {
          const codes = res.data.data.map((s) => s.code).filter(Boolean);
          this.setState({ stations: codes });
        }
      })
      .catch((e) => console.error(e));
  };

  handleEvent = (msg) => {
    if (msg.station == this.station_code) {
      if (msg.data && msg.data.id) {
        if (msg.action === 'add') {
          this.setState({ docs: [msg.data, ...this.state.docs] }, () => {
            this.filterDocs();
          });
        }
        if (msg.action === 'update') {
          const docs = [...this.state.docs];
          const index = docs.findIndex((c) => msg.data && c.id === msg.data.id);
          if (index > -1) {
            docs[index] = { ...msg.data };
            this.setState({ docs }, () => {
              if (this.state.searchOptions.verified) {
                if (this.state.docId === msg.data.id) {
                  this.selectDoc(docs[index]);
                }
              } else {
                if (this.state.docId === msg.data.id && msg.data.verified) {
                  this.clearDoc();
                } else {
                  this.selectDoc(docs[index]);
                }
              }
              this.filterDocs();
            });
          } else {
            this.fetchDocs(false);
          }
        }
      }
    }
    if (msg.action === 'delete') {
      const docs = [...this.state.docs];
      const index = docs.findIndex((c) => msg.data && c.id === msg.data.id);
      if (index > -1) {
        docs.splice(index, 1);
        this.setState({ docs }, () => {
          this.filterDocs();
        });
      }
      const docStack = [...this.state.stackDocs];
      const stackIndex = docStack.findIndex((c) => msg.data && c.id === msg.data.id);
      if (stackIndex > -1) {
        docStack.splice(stackIndex, 1);
        this.setState({ stackDocs: docStack });
      }
    }
  };

  handleStackEvent = (msg) => {
    if (msg.action === 'add' && msg.data) {
      this.setState({ stackDocs: [...this.state.stackDocs, msg.data] });
    }
    if (msg.action === 'update' && msg.data) {
      const docs = [...this.state.stackDocs];
      const index = docs.findIndex((c) => c.id === msg.data.id);
      if (index > -1) {
        docs[index] = { ...msg.data };
        this.setState({
          stackDocs: docs,
          processingDoc: {},
        });
      } else {
        this.fetchStackDocs();
      }
    }
  };

  fetchDocs = (search = false) => {
    let query = '';
    if (search) {
      query = `awb=${this.state.searchOptions.awb}`;
    } else {
      query = `start=${dateToUTC(
        dayjs(this.state.searchOptions.start).format('YYYY-MM-DD') + ' 00:00',
        'YYYY-MM-DD HH:mm'
      )}&end=${dateToUTC(
        dayjs(this.state.searchOptions.end).format('YYYY-MM-DD') + ' 23:59',
        'YYYY-MM-DD HH:mm'
      )}`;
    }
    const url = `/docs_list?${query}`;
    http
      .get(url, this.state.searchOptions)
      .then((response) => {
        this.setState({ docs: response.data.data || [] }, () => {
          this.filterDocs();
        });
      })
      .catch(() => {
        this.setState({ docs: [] }, () => {
          this.filterDocs();
        });
      });
  };

  filterDocs = () => {
    let data = [...(this.state.docs || [])];
    if (!this.state.searchOptions.awb) {
      if (this.state.searchOptions.verified) {
        data = data.filter((d) => d.verified === true);
      } else {
        data = data.filter((d) => d.verified === false);
      }
    }
    if (this.state.searchOptions.identity === 'unknown') {
      data = data.filter((d) => d.name === null);
    }
    if (this.state.searchOptions.identity === 'identified') {
      data = data.filter((d) => d.name !== null);
    }
    this.setState({ data }, () => {
      const targetId =
        this.props.match?.params?.id ||
        new URLSearchParams(this.props.location?.search || '').get('docId') ||
        this.props.location?.state?.docId ||
        (this.state.doc?.id ? String(this.state.doc.id) : null) ||
        sessionStorage.getItem('docsStream_selectedDocId');

      let targetDoc = null;
      if (targetId) {
        targetDoc = this.state.data.find((doc) => String(doc.id) === String(targetId));
      }

      if (targetDoc) {
        this.selectDoc(targetDoc);
      } else if (data.length > 0 && !this.state.data.find((doc) => doc.id === this.state.doc?.id)) {
        this.selectDoc(data[0]);
      } else if (data.length === 0 && !this.props.match?.params?.id) {
        this.clearDoc();
      }
    });
  };

  fetchStackDocs = () => {
    http
      .get('/doc_stack')
      .then((response) => {
        this.setState({ stackDocs: response.data.data?.docs || [] });
      })
      .catch(() => {
        this.setState({ stackDocs: [] });
      });
  };

  clearDoc = () => {
    this.setState({
      doc: null,
      docId: 0,
      docData: [],
      fwbData: null,
      fwbLines: [],
      fwbRawText: '',
      fwbVersions: [],
      selectedFwbVersion: 1,
      fwbWarnings: [],
      fwbTactIssues: [],
      fwbErrors: [],
      fwbGenerated: false,
      lastGeneratedDate: '',
    });
  };

  selectDoc = (doc) => {
    if (!doc) return;
    const docId = doc.id;
    try {
      sessionStorage.setItem('docsStream_selectedDocId', String(docId));
      sessionStorage.setItem('docsStream_selectedDoc', JSON.stringify(doc));
    } catch (e) {
      console.error(e);
    }

    const freshDoc =
      (this.state.data || []).find((d) => String(d.id) === String(docId)) ||
      (this.state.docs || []).find((d) => String(d.id) === String(docId)) ||
      doc;

    const activeDoc = {
      ...freshDoc,
      ...doc,
      data: {
        ...(freshDoc.data || {}),
        ...(doc.data || {}),
        caba_ai_chat:
          (Array.isArray(doc.data?.caba_ai_chat) && doc.data.caba_ai_chat.length > 0)
            ? doc.data.caba_ai_chat
            : (Array.isArray(freshDoc.data?.caba_ai_chat) && freshDoc.data.caba_ai_chat.length > 0)
              ? freshDoc.data.caba_ai_chat
              : (doc.data?.caba_ai_chat || freshDoc.data?.caba_ai_chat || []),
      },
    };

    this.setState({
      doc: activeDoc,
      docId,
      docData: [activeDoc],
    });
    this.processDocData(activeDoc);
    if (this.props.history && this.props.match?.params?.id !== String(docId)) {
      this.props.history.replace({
        pathname: `/doc_fwb/${docId}`,
        state: {
          docId,
          doc: activeDoc,
        },
      });
    }
  };

  handleChange = (event, type) => {
    const rawVal = event?.target ? event.target.value : event;
    const value = type === 'verified' ? !this.state.searchOptions.verified : rawVal;
    const searchOptions = {
      ...this.state.searchOptions,
      [type]: value,
      ...(type === 'verified' && value ? { identity: 'all' } : {}),
    };
    try {
      sessionStorage.setItem('docsStream_searchOptions', JSON.stringify(searchOptions));
    } catch (e) {
      console.error(e);
    }
    this.setState({ searchOptions }, () => {
      if (type === 'identity' || type === 'verified') {
        this.filterDocs();
      } else if (type !== 'awb' || !value) {
        this.fetchDocs(false);
      }
    });
  };

  handleOpen = (modal, data = {}) => {
    let modalData = data || {};
    let country_code = '';
    let contactNumber = data.requests?.[0]?.contact_type === 'email' ? data.requests?.[0]?.contact : '';
    if (modal === 'addDoc') {
      modalData = {
        ...data,
        party_name: '',
        name: '',
        type: 'AWB',
        contact_type: 'sms',
        country_code: '+1',
        contact: '',
        note: '',
      };
    }
    if (modal === 'thirdPartyDoc') {
      if (data.requests?.length > 0) {
        const mobile = `${data.requests?.[0]?.contact}`;
        const match = mobile.match(/^(\+\d{1,4})(\d{10})$/);
        if (match) {
          country_code = match[1];
          contactNumber = match[2];
        }
      }
      modalData = {
        ...data,
        ...(data?.requests?.[0] || {}),
        country_code,
        contact: contactNumber,
      };
    }
    this.setState({
      modal,
      docFields: modalData,
      docErrors: {},
      fileType: 'third',
    });
  };

  onClose = () => {
    this.setState({
      modal: false,
      exModal: false,
      docFields: {},
      docErrors: {},
      uploadError: '',
      isEditable: false,
      fileType: 'third',
    });
  };

  handlePopover = (open, target) => {
    this.setState({
      attachment: open,
      anchorEl: target,
    });
  };

  handlePopoverClose = () => {
    this.setState({
      attachment: false,
      anchorEl: null,
    });
  };

  handleDelete = (id, anchorEl) => {
    this.props.setDelete({
      modal: true,
      id,
      anchorEl,
      onConfirm: () => this.deleteDoc(id),
    });
  };

  deleteDoc = (id) => {
    this.props.setDelete({ modal: false, });
    http
      .delete(`/document/${id}`)
      .then(({ data }) => {
        if (data.status === 'success') {
          toast.success(data.message);
          const docs = [...this.state.docs];
          const index = docs.findIndex((c) => c.id === id);
          if (index > -1) {
            docs.splice(index, 1);
            this.setState({ docs }, () => {
              this.filterDocs();
            });
          }
        }
      })
      .catch((err) => {
        toast.error(err.response?.data?.message || 'Failed to delete');
      });
  };

  formatPhoneNumberForTwilio = (input) => {
    if (!input) return '';
    const cleaned = input.replace(/\D/g, '');
    return `${cleaned}`;
  };

  onhandleChange = (e, fileType) => {
    const state = {};
    if (fileType || e?.target?.name === 'fileType') {
      const type = fileType || e.target.value;
      if (type === 'third') {
        state.docFields = {
          party_name: '',
          name: '',
          type: 'AWB',
          contact_type: 'sms',
          country_code: '+1',
          contact: '',
          note: '',
        };
      }
      state.fileType = type;
    } else if (e?.target?.name === 'attachTo') {
      state.attachTo = e.target.value;
    } else if (e?.target?.name === 'addDocType') {
      state.addDocType = e.target.value;
    } else if (e?.target?.value) {
      state.addDocType = e.target.value;
    }
    state.docErrors = {};
    this.setState(state);
  };

  onChangeDoc = (event, type) => {
    let fieldName = type;
    let value = event;
    if (event && event.target) {
      fieldName = event.target.name || type;
      value = event.target.type === 'file' ? event.target.files?.[0] : event.target.value;
    }
    if (this.state.docFields?.contact_type === 'sms' && fieldName === 'contact' && typeof value === 'string') {
      value = this.formatPhoneNumberForTwilio(value);
    }
    const errors = { ...this.state.docErrors };
    if (fieldName) {
      delete errors[fieldName];
    }
    if (event?.target?.files?.[0]) {
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.onload = (e) => {
        this.setState({
          docFields: {
            ...this.state.docFields,
            file: file,
            preview: e.target.result,
          },
          docErrors: errors,
        });
      };
      reader.readAsDataURL(file);
    } else {
      this.setState({
        docFields: {
          ...this.state.docFields,
          ...(fieldName ? { [fieldName]: value } : {}),
        },
        docErrors: errors,
      });
    }
  };

  validateThirdPartyForm = () => {
    const docFields = { ...this.state.docFields };
    const error = {};
    let isValid = true;
    if (!docFields.party_name || docFields.party_name.trim().length === 0) {
      error.party_name = true;
      isValid = false;
    }
    if (!docFields.type || docFields.type.trim().length === 0) {
      error.type = true;
      isValid = false;
    }
    if (docFields.contact_type === 'sms') {
      if (!docFields.country_code) {
        error.country_code = true;
        isValid = false;
      }
      if (!docFields.contact || docFields.contact.trim().length < 10) {
        error.contact = true;
        isValid = false;
      }
      if (docFields.contact && !/^(\+\d{1,3})?\d{10}$/.test(docFields.contact)) {
        isValid = false;
        error.contact = 'Enter valid mobile number';
      }
    } else if (docFields.contact_type === 'email') {
      if (!docFields.contact || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(docFields.contact)) {
        error.contact = 'Enter valid email address';
        isValid = false;
      }
    }
    this.setState({ docErrors: error });
    return isValid;
  };

  onSubmitReq = (e) => {
    e.preventDefault();
    if (this.validateThirdPartyForm()) {
      const formdata = { ...this.state.docFields };
      if (formdata.contact_type === 'sms') {
        const country_code = formdata.country_code ? formdata.country_code : '';
        formdata.contact = country_code + formdata.contact;
      }
      formdata.awb_no = this.state.docFields.awb_no;
      http.post('/doc_req', formdata).then(({ data }) => {
        if (data.status === 'success') {
          toast.success(data.message || 'Request sent successfully');
          this.setState({
            modal: false,
            docFields: {},
            docErrors: {},
          });
          this.fetchDocs(false);
        }
      }).catch((err) => {
        toast.error(err.response?.data?.message || 'Failed to submit request');
      });
    }
  };

  onUpdateReq = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (this.validateThirdPartyForm()) {
      const formdata = { ...this.state.docFields };
      if (formdata.contact_type === 'sms') {
        const country_code = formdata.country_code ? formdata.country_code : '';
        formdata.contact = country_code + formdata.contact;
      }
      http.post(`/doc_req/${formdata.id}`, formdata).then(({ data }) => {
        if (data.status === 'success') {
          toast.success(data.message || 'Request updated successfully');
          this.setState({
            modal: false,
            docFields: {},
            docErrors: {},
            isEditable: false,
          });
          this.fetchDocs(false);
        }
      }).catch((err) => {
        toast.error(err.response?.data?.message || 'Failed to update request');
      });
    }
  };

  handleReminder = (id) => {
    const docId = typeof id === 'object' && id !== null ? id.id : id;
    http.get(`/doc_req/reminder/${docId}`).then(({ data }) => {
      if (data.status === 'success') {
        toast.success(data.message || 'Reminder sent successfully');
      }
    }).catch((err) => {
      toast.error(err.response?.data?.message || 'Failed to send reminder');
    });
  };

  handleEditDoc = () => {
    this.setState({ isEditable: true });
  };

  closeEditDoc = () => {
    this.setState({ isEditable: false });
  };

  handleToggle = (event, value) => {
    this.setState({ value });
  };

  attachAwb = () => {
    http.get(`/doc_stream/attach_awb/${this.state.docId}/${this.state.exData.id}`).then(() => {
      this.setState({
        exModal: false,
        exData: {},
      });
      this.fetchDocs(false);
    });
  };

  parseAddress = (addrStr) => {
    if (!addrStr || typeof addrStr !== 'string') return {};
    const tokens = addrStr.trim().split(/[\s,]+/);
    let country = '';
    let postalZipCode = '';
    let cityPlace = '';

    if (tokens.length > 1 && /^[A-Z]{2}$/i.test(tokens[tokens.length - 1])) {
      country = tokens[tokens.length - 1].toUpperCase();
    }
    const zipIndex = country ? tokens.length - 2 : tokens.length - 1;
    if (zipIndex >= 0 && /^(\d{4,7}(-\d{4})?|[A-Z0-9]{3,8})$/i.test(tokens[zipIndex])) {
      postalZipCode = tokens[zipIndex];
    }
    const cityIndex = postalZipCode ? zipIndex - 1 : (country ? tokens.length - 2 : tokens.length - 1);
    if (cityIndex >= 0 && cityIndex < tokens.length) {
      cityPlace = tokens[cityIndex];
    }

    return {
      country,
      postalZipCode,
      cityPlace,
    };
  };

  mapDocStreamToFwb = (doc) => {
    if (!doc) return null;
    const scan = doc.data || {};
    const awb = doc.awb || {};
    const flight = doc.flight || {};

    const awbNumber =
      scan.awb_no ||
      (awb.code && awb.number ? `${awb.code}-${awb.number}` : '') ||
      doc.name ||
      '';

    let routingAndFlights = [];
    if (Array.isArray(scan.flights) && scan.flights.length > 0) {
      routingAndFlights = scan.flights.map((f) => {
        const fNo = f.flight_no || f.flightNumber || '';
        const fCarrier = f.airline || f.carrier || (fNo.length > 2 && isNaN(fNo.substring(0, 2)) ? fNo.substring(0, 2) : '');
        const fDate = f.flight_date || f.date || '';
        return {
          to: f.dest || f.to || scan.dest || awb.dest || '',
          byCarrier: fCarrier,
          flightNumber: fNo,
          date: fDate ? String(fDate).split('T')[0].split(' ')[0] : '',
        };
      });
    } else if (scan.flight_no || awb.flight_no || flight.flight_no) {
      const flightNoStr = String(scan.flight_no || awb.flight_no || flight.flight_no || '').trim();
      let carrier = scan.airline || awb.airline?.code || flight.airline?.code || '';
      if (!carrier && flightNoStr.length > 2 && isNaN(flightNoStr.substring(0, 2))) {
        carrier = flightNoStr.substring(0, 2).toUpperCase();
      }
      if (!carrier && (awb.code === '020' || scan.awb_no?.startsWith('020'))) {
        carrier = 'LH';
      }
      const rawDate = scan.flight_date || awb.flight_date || flight.flight_date || '';
      const dateFormatted = rawDate ? String(rawDate).split('T')[0].split(' ')[0] : '';
      routingAndFlights = [
        {
          to: scan.dest || awb.dest || awb.destination || '',
          byCarrier: carrier,
          flightNumber: flightNoStr,
          date: dateFormatted,
        },
      ];
    }

    const parsedConsignee = this.parseAddress(scan.consignee_address || awb.consignee_address || '');
    const parsedShipper = this.parseAddress(scan.shipper_address || awb.shipper_address || '');

    let forwarderCity = scan.forwarder_city || scan.agent_city || '';
    const forwarderStr = scan.forwarder || scan.issuing_carrier_agent || awb.forwarder || awb.agent || '';
    if (!forwarderCity && forwarderStr.includes(',')) {
      const parts = forwarderStr.split(',');
      forwarderCity = parts[parts.length - 1].trim();
    }

    const natureOfGoods = Array.isArray(scan.nature_of_goods)
      ? scan.nature_of_goods
      : scan.nature_of_goods
        ? [scan.nature_of_goods]
        : awb.nature_of_goods
          ? [awb.nature_of_goods]
          : [];

    const specialHandlingCodes = Array.isArray(scan.special_handling_codes)
      ? scan.special_handling_codes
      : Array.isArray(scan.specialHandlingCodes)
        ? scan.specialHandlingCodes
        : Array.isArray(scan.spl_handling)
          ? scan.spl_handling
          : scan.spl_handling
            ? [scan.spl_handling]
            : [];

    const rawAcc = scan.accounting_information || scan.accountingInformation || [];
    const accountingInformation = (Array.isArray(rawAcc) ? rawAcc : rawAcc ? [rawAcc] : []).map((item) => {
      if (typeof item === 'string') {
        const [id, ...rest] = item.includes('/') ? item.split('/') : [item.substring(0, 3), item.substring(3)];
        return {
          identifier: id?.trim() || '',
          information: rest.join('/').trim(),
        };
      }
      return {
        identifier: item?.identifier || item?.id || '',
        information: item?.information || item?.info || item?.text || '',
      };
    });
    while (accountingInformation.length < 2) {
      accountingInformation.push({
        identifier: '',
        information: '',
      });
    }

    const rawOci = scan.other_customs_security_information || scan.otherCustomsSecurityInformation || [];
    const otherCustomsSecurityInformation = (Array.isArray(rawOci) ? rawOci : rawOci ? [rawOci] : []).map((item) => {
      if (typeof item === 'string') {
        const [c = '', t = '', code = '', ...rest] = item.split('/');
        return {
          countryCode: c,
          informationType: t,
          informationCode: code,
          information: rest.join('/'),
        };
      }
      return {
        countryCode: item?.countryCode || item?.country_code || item?.country || '',
        informationType: item?.informationType || item?.information_type || item?.type || '',
        informationCode: item?.informationCode || item?.information_code || item?.code || '',
        information: item?.information || item?.info || '',
      };
    });
    if (otherCustomsSecurityInformation.length === 0) {
      otherCustomsSecurityInformation.push({
        countryCode: '',
        informationType: '',
        informationCode: '',
        information: '',
      });
    }

    const baseData = {
      docId: doc.id,
      awbNumber,
      awbSrc: doc.src || '',
      shipmentDetails: {
        origin: scan.org || scan.airport_of_departure || awb.origin || '',
        destination: scan.dest || scan.airport_of_destination || awb.destination || '',
        pieces: scan.pcs !== undefined && scan.pcs !== null ? scan.pcs : (scan.pieces || awb.pieces || ''),
        weight: scan.wgt !== undefined && scan.wgt !== null ? scan.wgt : (scan.gross_weight || awb.weight || ''),
        unit: scan.weight_unit || scan.unit || 'KG',
      },
      routingAndFlights,
      shipper: {
        name: scan.shipper || scan.shipper_name || awb.shipper || '',
        address: scan.shipper_address || awb.shipper_address || '',
        cityPlace: scan.shipper_city || scan.shipper_place || parsedShipper.cityPlace || '',
        stateProvince: scan.shipper_state || scan.shipper_province || '',
        country: scan.shipper_country || parsedShipper.country || '',
        postalZipCode: scan.shipper_zip || scan.shipper_postal_code || parsedShipper.postalZipCode || '',
        contactType: scan.shipper_contact_type || 'EM',
        contactNumber: scan.shipper_contact || scan.shipper_phone || '',
        shippersAccount: scan.shipper_account || scan.shippers_account || '',
      },
      consignee: {
        name: scan.consignee || scan.consignee_name || scan.notify || awb.consignee || '',
        address: scan.consignee_address || awb.consignee_address || '',
        cityPlace: scan.consignee_city || scan.consignee_place || parsedConsignee.cityPlace || '',
        stateProvince: scan.consignee_state || scan.consignee_province || '',
        country: scan.consignee_country || parsedConsignee.country || '',
        postalZipCode: scan.consignee_zip || scan.consignee_postal_code || parsedConsignee.postalZipCode || '',
        contactType: scan.consignee_contact_type || 'TE',
        contactNumber: scan.consignee_contact || scan.consignee_phone || '',
        consigneesAccount: scan.consignee_account || scan.consignees_account || '',
      },
      issuingCarriersAgent: {
        name: forwarderStr,
        city: forwarderCity,
        iataCode: scan.forwarder_iata || scan.iata_code || '',
        accountNumber: scan.forwarder_account || scan.account_number || '',
      },
      accountingInformation,
      chargeDeclaration: {
        currency: scan.currency || scan.chargeDeclaration?.currency || 'USD',
        chgsCode: scan.chgs_code || scan.chargeDeclaration?.chgsCode || 'PP',
        pcWeightVal: scan.pc_weight_val || scan.chargeDeclaration?.pcWeightVal || '',
        pcOther: scan.pc_other || scan.chargeDeclaration?.pcOther || '',
        declaredValueForCarriage: scan.declared_value_carriage || scan.chargeDeclaration?.declaredValueForCarriage || 'NVD',
        declaredValueForCustoms: scan.declared_value_customs || scan.chargeDeclaration?.declaredValueForCustoms || 'NCV',
        amountOfInsurance: scan.amount_insurance || scan.chargeDeclaration?.amountOfInsurance || 'NIL',
      },
      ratingDetails: {
        piecesRcp: scan.pcs !== undefined && scan.pcs !== null ? scan.pcs : (scan.pieces || awb.pcs || awb.pieces || ''),
        grossWeight: scan.wgt !== undefined && scan.wgt !== null ? scan.wgt : (scan.gross_weight || awb.wgt || awb.weight || ''),
        weightUnit: scan.weight_unit || scan.unit || 'KG',
        rateClass: scan.rate_class || scan.ratingDetails?.rateClass || '',
        commodityItemNo: scan.commodity_item_no || scan.ratingDetails?.commodityItemNo || '',
        chargeableWeight: scan.chargeable_weight !== undefined && scan.chargeable_weight !== null ? scan.chargeable_weight : (scan.chargeable_wgt || ''),
        rateCharge: scan.rate_charge || scan.ratingDetails?.rateCharge || '',
        totalCharge: scan.total_charge || scan.ratingDetails?.totalCharge || '',
        harmonisedCommodityCode: scan.harmonised_commodity_code || scan.harmonised_code || '',
        countryOfOrigin: scan.country_of_origin || parsedShipper.country || '',
        natureOfGoods,
        dimensions: scan.dimensions || scan.ratingDetails?.dimensions || {
          unit: '',
          measurements: [],
        },
        uldInformation: scan.uld_information || scan.ulds || scan.ratingDetails?.uldInformation || [],
        slac: scan.slac || scan.ratingDetails?.slac || (scan.pcs !== undefined && scan.pcs !== null ? scan.pcs : (awb.pcs || '')),
      },
      otherCharges: scan.other_charges || scan.otherCharges || [],
      chargeSummary: scan.charge_summary || scan.chargeSummary || {},
      shippersCertification: { shipperAgentsName: scan.shipper_agents_name || scan.shipper_signature || scan.shippersCertification?.shipperAgentsName || '', },
      specialServiceRequest: scan.special_service_request || scan.specialServiceRequest || [],
      otherServiceInformation: scan.other_service_information || scan.otherServiceInformation || {},
      specialHandlingCodes,
      otherCustomsSecurityInformation,
      caba_ai_chat: scan.caba_ai_chat || [],
    };

    const fwbRaw =
      doc?.data?.fwb_raw ||
      doc?.fwb ||
      doc?.data?.fwb ||
      (Array.isArray(doc?.data?.fwb_versions) &&
        doc.data.fwb_versions.find((v) => v.version === doc.data.selected_fwb_version)?.fwb) ||
      (Array.isArray(doc?.data?.fwb_versions) && doc.data.fwb_versions[doc.data.fwb_versions.length - 1]?.fwb) ||
      '';
    if (fwbRaw) {
      return hydrateFormDataFromFwb(baseData, fwbRaw);
    }
    return baseData;
  };

  processDocData = (doc) => {
    const mappedFwbData = this.mapDocStreamToFwb(doc);
    const fwbRaw = doc?.data?.fwb_raw;
    const fwbGeneratedAt = doc?.data?.fwb_generated_at;
    const fwbVersions =
      Array.isArray(doc?.data?.fwb_versions) && doc.data.fwb_versions.length > 0
        ? doc.data.fwb_versions
        : fwbRaw
          ? [
            {
              version: 1,
              name: 'Version 1',
              fwb: fwbRaw,
              created_at: fwbGeneratedAt,
              source: 'generated',
            },
          ]
          : [];
    const selectedFwbVersion = doc?.data?.selected_fwb_version || (fwbVersions.length > 0 ? fwbVersions[0].version : 1);
    const currentVerObj = fwbVersions.find((v) => Number(v.version) === Number(selectedFwbVersion)) || fwbVersions[0];

    const fwbValidation = currentVerObj?.validation || doc?.data?.fwb_validation || null;
    const fwbWarnings = (currentVerObj?.warnings !== undefined ? currentVerObj.warnings : null)
      || currentVerObj?.validation?.warnings
      || doc?.data?.fwb_warnings
      || fwbValidation?.warnings
      || [];
    const fwbTactIssues = (currentVerObj?.tactIssues !== undefined ? currentVerObj.tactIssues : null)
      || currentVerObj?.validation?.tactIssues
      || doc?.data?.fwb_tact_issues
      || fwbValidation?.tactIssues
      || [];
    const fwbErrors = (currentVerObj?.errors !== undefined ? currentVerObj.errors : null)
      || currentVerObj?.validation?.errors
      || doc?.data?.fwb_errors
      || fwbValidation?.errors
      || [];
    const hasTactBreach = currentVerObj?.hasTactBreach !== undefined
      ? Boolean(currentVerObj.hasTactBreach)
      : (doc?.data?.has_tact_breach !== undefined
        ? Boolean(doc.data.has_tact_breach)
        : Boolean(fwbValidation?.hasTactBreach));

    if (fwbRaw) {
      const lines = typeof fwbRaw === 'string' ? fwbRaw.split(/\r?\n/).filter(Boolean) : [];
      let formattedDate = '15MAY26';
      if (fwbGeneratedAt) {
        formattedDate = moment(fwbGeneratedAt).isValid()
          ? moment(fwbGeneratedAt).format('DDMMMYY').toUpperCase()
          : String(fwbGeneratedAt).toUpperCase();
      } else {
        const isuLine = lines.find((l) => l.startsWith('ISU/'));
        if (isuLine) {
          const isuToken = isuLine.split('/')[1];
          if (isuToken) {
            formattedDate = isuToken.toUpperCase();
          }
        }
      }

      this.setState({
        doc,
        docId: doc.id,
        fwbData: mappedFwbData,
        fwbLines: lines,
        fwbRawText: fwbRaw,
        fwbVersions,
        selectedFwbVersion,
        fwbWarnings,
        fwbTactIssues,
        fwbErrors,
        hasTactBreach,
        fwbValidation,
        fwbGenerated: true,
        lastGeneratedDate: formattedDate,
        isFwbLoading: false,
      }, () => {
        // If document has FWB raw message but lacks validation (or legacy schema without tactIssues), refresh validation once:
        if (fwbRaw && (!fwbValidation || fwbValidation.tactIssues === undefined)) {
          this.handleValidateFwb(fwbRaw);
        }
      });
    } else {
      this.setState({
        doc,
        docId: doc.id,
        fwbData: mappedFwbData,
        fwbLines: [],
        fwbRawText: '',
        fwbVersions: [],
        selectedFwbVersion: 1,
        fwbWarnings: [],
        fwbTactIssues: [],
        hasTactBreach: false,
        fwbValidation: null,
        fwbGenerated: false,
        lastGeneratedDate: '',
        isFwbLoading: false,
      });
    }
  };

  handleValidateFwb = (fwbMessageToValidate) => {
    const { doc, fwbRawText, selectedFwbVersion } = this.state;
    const docId = doc?.id;
    const message = fwbMessageToValidate || fwbRawText;

    const requestId = Date.now();
    this.latestValidationRequestId = requestId;
    const targetVersion = selectedFwbVersion;

    return http
      .post('/doc_fwb/validate', {
        docId,
        fwbMessage: message,
      })
      .then((res) => {
        // Guard against race conditions: check if this request is still current
        if (this.latestValidationRequestId !== requestId) return null;
        if (this.state.selectedFwbVersion !== targetVersion) return null;

        const payload = res?.data?.data;
        if (payload) {
          const validation = payload.validation || null;
          const warnings = payload.warnings || validation?.warnings || [];
          const tactIssues = payload.tactIssues || validation?.tactIssues || [];
          const errors = payload.errors || validation?.errors || [];
          const hasTactBreach = payload.hasTactBreach !== undefined ? Boolean(payload.hasTactBreach) : Boolean(validation?.hasTactBreach);

          this.setState((prevState) => {
            if (prevState.selectedFwbVersion !== targetVersion) return null;

            const updatedVersions = (prevState.fwbVersions || []).map((ver) => {
              if (Number(ver.version) === Number(targetVersion)) {
                return {
                  ...ver,
                  validation,
                  warnings,
                  tactIssues,
                  errors,
                  hasTactBreach,
                  isValid: Boolean(validation?.isValid),
                };
              }
              return ver;
            });

            const updatedDoc = prevState.doc
              ? {
                ...prevState.doc,
                data: {
                  ...(prevState.doc.data || {}),
                  fwb_versions: updatedVersions,
                  fwb_warnings: warnings,
                  fwb_tact_issues: tactIssues,
                  fwb_errors: errors,
                  has_tact_breach: hasTactBreach,
                  fwb_validation: validation,
                },
              }
              : prevState.doc;

            return {
              doc: updatedDoc,
              fwbVersions: updatedVersions,
              fwbWarnings: warnings,
              fwbTactIssues: tactIssues,
              fwbErrors: errors,
              hasTactBreach: hasTactBreach,
              fwbValidation: validation,
            };
          });
          return payload;
        }
      })
      .catch((err) => {
        console.error('Error validating FWB:', err);
      });
  };

  handleGenerateFwb = () => {
    const { doc, fwbData } = this.state;
    const docId = doc?.id || fwbData?.docId || this.props.match?.params?.id;
    const src = doc?.src || fwbData?.awbSrc;

    if (!docId && !src) {
      toast.error('No document or file available to generate FWB');
      return;
    }

    this.setState({ isGeneratingFwb: true });
    http
      .post('/doc_fwb/extract', {
        docId,
        src,
      })
      .then((res) => {
        const payload = res?.data?.data;
        if (payload && (payload.lines || payload.fwb)) {
          const lines = payload.lines || (typeof payload.fwb === 'string' ? payload.fwb.split(/\r?\n/).filter(Boolean) : []);
          const rawDate = payload.fwb_generated_at || new Date();
          const formattedDate = moment(rawDate).isValid()
            ? moment(rawDate).format('DDMMMYY').toUpperCase()
            : String(rawDate).toUpperCase();

          const rawVersions =
            payload.fwb_versions ||
            doc?.data?.fwb_versions || [
              {
                version: 1,
                name: 'Version 1',
                fwb: payload.fwb,
                created_at: rawDate,
                source: 'generated',
              },
            ];

          const validation = payload.validation || null;
          const warnings = payload.warnings || validation?.warnings || [];
          const tactIssues = payload.tactIssues || validation?.tactIssues || [];
          const errors = payload.errors || validation?.errors || [];
          const hasTactBreach = payload.hasTactBreach !== undefined ? Boolean(payload.hasTactBreach) : Boolean(validation?.hasTactBreach);

          const versions = (rawVersions || []).map((v) => {
            if (Number(v.version) === 1) {
              return {
                ...v,
                validation,
                warnings,
                tactIssues,
                errors,
                hasTactBreach,
                isValid: Boolean(validation?.isValid),
              };
            }
            return v;
          });

          const updatedDoc = doc
            ? {
              ...doc,
              data: {
                ...(doc.data || {}),
                fwb_raw: payload.fwb,
                fwb_generated_at: payload.fwb_generated_at || new Date().toISOString(),
                selected_fwb_version: payload.selected_fwb_version || 1,
                fwb_versions: versions,
                fwb_warnings: warnings,
                fwb_tact_issues: tactIssues,
                fwb_errors: errors,
                has_tact_breach: hasTactBreach,
                fwb_validation: validation,
              },
            }
            : doc;

          this.setState({
            doc: updatedDoc,
            fwbLines: lines,
            fwbRawText: payload.fwb || '',
            fwbVersions: versions,
            selectedFwbVersion: payload.selected_fwb_version || 1,
            fwbWarnings: warnings,
            fwbTactIssues: tactIssues,
            fwbErrors: errors,
            hasTactBreach: hasTactBreach,
            fwbValidation: validation,
            fwbGenerated: true,
            lastGeneratedDate: formattedDate,
            isGeneratingFwb: false,
            fwbData: this.mapDocStreamToFwb(updatedDoc),
          });

          if (this.props.history && updatedDoc) {
            this.props.history.replace({
              pathname: `/doc_fwb/${updatedDoc.id || docId}`,
              state: {
                docId: updatedDoc.id || docId,
                doc: updatedDoc,
              },
            });
          }
          toast.success('FWB generated successfully');
        } else {
          this.setState({ isGeneratingFwb: false });
          toast.error('Failed to generate FWB');
        }
      })
      .catch((err) => {
        console.error('Error generating FWB:', err);
        this.setState({ isGeneratingFwb: false });
        const errorMsg = err?.response?.data?.message || 'Failed to generate FWB';
        toast.error(errorMsg);
      });
  };

  handleSaveFwb = ({ fwbMessage, saveType, targetVersion, versionName, source, prompt, guidelines, modelId, messageId, prevFwb, changes }) => {
    const { doc, fwbData, selectedFwbVersion } = this.state;
    const docId = doc?.id || fwbData?.docId || this.props.match?.params?.id;

    if (!docId || !fwbMessage) {
      toast.error('Cannot save: Document ID or FWB message is missing');
      return Promise.reject(new Error('Missing docId or fwbMessage'));
    }

    return http
      .post('/doc_fwb/save', {
        docId,
        fwbMessage,
        saveType: saveType || 'overwrite',
        targetVersion: targetVersion || selectedFwbVersion || 1,
        versionName,
        source: source || 'manual',
        prompt,
        guidelines,
        modelId,
        messageId,
        prevFwb: prevFwb || this.state.fwbRawText || null,
        changes: changes || null,
      })
      .then((res) => {
        const payload = res?.data?.data;
        if (payload) {
          const lines = payload.lines || (typeof payload.fwb === 'string' ? payload.fwb.split(/\r?\n/).filter(Boolean) : []);
          const rawDate = payload.fwb_generated_at || new Date();
          const formattedDate = moment(rawDate).isValid()
            ? moment(rawDate).format('DDMMMYY').toUpperCase()
            : String(rawDate).toUpperCase();
          const validation = payload.validation || null;
          const warnings = payload.warnings || validation?.warnings || [];
          const tactIssues = payload.tactIssues || validation?.tactIssues || [];
          const errors = payload.errors || validation?.errors || [];
          const hasTactBreach = payload.hasTactBreach !== undefined ? Boolean(payload.hasTactBreach) : Boolean(validation?.hasTactBreach);

          const prevVersions = this.state.fwbVersions || [];
          const rawServerVersions = Array.isArray(payload.fwb_versions) && payload.fwb_versions.length > 0
            ? payload.fwb_versions
            : prevVersions;

          const mergedVersions = rawServerVersions.map((newVer) => {
            const existingMatch = prevVersions.find((p) => Number(p.version) === Number(newVer.version));
            return {
              ...newVer,
              validation: newVer.validation || existingMatch?.validation || null,
              warnings: (newVer.warnings !== undefined && newVer.warnings !== null) ? newVer.warnings : (existingMatch?.warnings || []),
              tactIssues: (newVer.tactIssues !== undefined && newVer.tactIssues !== null) ? newVer.tactIssues : (existingMatch?.tactIssues || []),
              errors: (newVer.errors !== undefined && newVer.errors !== null) ? newVer.errors : (existingMatch?.errors || []),
              hasTactBreach: newVer.hasTactBreach !== undefined ? Boolean(newVer.hasTactBreach) : Boolean(existingMatch?.hasTactBreach),
            };
          });

          const savedVerNum = Number(payload.selected_fwb_version || targetVersion || selectedFwbVersion || 1);
          const savedVerMatch = mergedVersions.find((v) => Number(v.version) === savedVerNum);
          if (savedVerMatch) {
            savedVerMatch.validation = validation;
            savedVerMatch.warnings = warnings;
            savedVerMatch.tactIssues = tactIssues;
            savedVerMatch.errors = errors;
            savedVerMatch.hasTactBreach = hasTactBreach;
            savedVerMatch.isValid = Boolean(validation?.isValid);
          }

          const updatedDoc = doc
            ? {
              ...doc,
              data: {
                ...(doc.data || {}),
                fwb_raw: payload.fwb,
                fwb_generated_at: payload.fwb_generated_at,
                selected_fwb_version: payload.selected_fwb_version,
                fwb_versions: mergedVersions,
                caba_ai_chat: payload.caba_ai_chat || doc.data?.caba_ai_chat || [],
                fwb_warnings: warnings,
                fwb_tact_issues: tactIssues,
                fwb_errors: errors,
                has_tact_breach: hasTactBreach,
                fwb_validation: validation,
              },
            }
            : doc;

          const updateDocList = (list) =>
            (list || []).map((d) => (String(d.id) === String(updatedDoc?.id) ? updatedDoc : d));

          this.setState({
            doc: updatedDoc,
            docs: updateDocList(this.state.docs),
            data: updateDocList(this.state.data),
            fwbLines: lines,
            fwbRawText: payload.fwb || '',
            fwbVersions: mergedVersions,
            selectedFwbVersion: payload.selected_fwb_version || 1,
            fwbWarnings: warnings,
            fwbTactIssues: tactIssues,
            fwbErrors: errors,
            hasTactBreach: hasTactBreach,
            fwbValidation: validation,
            fwbGenerated: true,
            lastGeneratedDate: formattedDate,
            fwbData: this.mapDocStreamToFwb(updatedDoc),
          });

          toast.success(res?.data?.message || 'FWB saved successfully');
          return payload;
        }
      })
      .catch((err) => {
        console.error('Error saving FWB:', err);
        const errMsg = err?.response?.data?.message || 'Failed to save FWB message';
        toast.error(errMsg);
        throw err;
      });
  };

  handleSelectFwbVersion = (version) => {
    const { doc, fwbData, fwbVersions } = this.state;
    const docId = doc?.id || fwbData?.docId || this.props.match?.params?.id;

    if (!docId || version === undefined || version === null) return;

    const targetVerNum = parseInt(version, 10);
    const targetVerObj = (fwbVersions || []).find((v) => Number(v.version) === targetVerNum);

    // Optimistically switch to the selected version's cached alerts immediately
    if (targetVerObj) {
      const vValidation = targetVerObj.validation || null;
      const vWarnings = targetVerObj.warnings || vValidation?.warnings || [];
      const vTactIssues = targetVerObj.tactIssues || vValidation?.tactIssues || [];
      const vErrors = targetVerObj.errors || vValidation?.errors || [];
      const vHasTactBreach = targetVerObj.hasTactBreach !== undefined ? Boolean(targetVerObj.hasTactBreach) : Boolean(vValidation?.hasTactBreach);
      const targetLines = typeof targetVerObj.fwb === 'string' ? targetVerObj.fwb.split(/\r?\n/).filter(Boolean) : [];

      this.setState({
        selectedFwbVersion: targetVerNum,
        fwbRawText: targetVerObj.fwb || '',
        fwbLines: targetLines,
        fwbWarnings: vWarnings,
        fwbTactIssues: vTactIssues,
        fwbErrors: vErrors,
        hasTactBreach: vHasTactBreach,
        fwbValidation: vValidation,
      });

      if (targetVerObj.fwb && (!vValidation || vValidation.tactIssues === undefined)) {
        this.handleValidateFwb(targetVerObj.fwb);
      }
    }

    return http
      .post('/doc_fwb/select-version', {
        docId,
        version,
      })
      .then((res) => {
        const payload = res?.data?.data;
        if (payload) {
          const lines = payload.lines || (typeof payload.fwb === 'string' ? payload.fwb.split(/\r?\n/).filter(Boolean) : []);
          const rawDate = payload.fwb_generated_at || new Date();
          const formattedDate = moment(rawDate).isValid()
            ? moment(rawDate).format('DDMMMYY').toUpperCase()
            : String(rawDate).toUpperCase();
          const validation = payload.validation || null;
          const warnings = payload.warnings || validation?.warnings || [];
          const tactIssues = payload.tactIssues || validation?.tactIssues || [];
          const errors = payload.errors || validation?.errors || [];
          const hasTactBreach = payload.hasTactBreach !== undefined ? Boolean(payload.hasTactBreach) : Boolean(validation?.hasTactBreach);

          const prevVersions = this.state.fwbVersions || fwbVersions || [];
          const rawServerVersions = Array.isArray(payload.fwb_versions) && payload.fwb_versions.length > 0
            ? payload.fwb_versions
            : prevVersions;

          const mergedVersions = rawServerVersions.map((newVer) => {
            const existingMatch = prevVersions.find((p) => Number(p.version) === Number(newVer.version));
            return {
              ...newVer,
              validation: newVer.validation || existingMatch?.validation || null,
              warnings: (newVer.warnings !== undefined && newVer.warnings !== null) ? newVer.warnings : (existingMatch?.warnings || []),
              tactIssues: (newVer.tactIssues !== undefined && newVer.tactIssues !== null) ? newVer.tactIssues : (existingMatch?.tactIssues || []),
              errors: (newVer.errors !== undefined && newVer.errors !== null) ? newVer.errors : (existingMatch?.errors || []),
              hasTactBreach: newVer.hasTactBreach !== undefined ? Boolean(newVer.hasTactBreach) : Boolean(existingMatch?.hasTactBreach),
            };
          });

          const targetVerMatch = mergedVersions.find((v) => Number(v.version) === Number(payload.selected_fwb_version));
          if (targetVerMatch) {
            if (validation) targetVerMatch.validation = validation;
            if (warnings) targetVerMatch.warnings = warnings;
            if (tactIssues) targetVerMatch.tactIssues = tactIssues;
            if (errors) targetVerMatch.errors = errors;
            if (hasTactBreach !== undefined) targetVerMatch.hasTactBreach = hasTactBreach;
            targetVerMatch.isValid = Boolean(validation?.isValid);
          }

          const updatedDoc = doc
            ? {
              ...doc,
              data: {
                ...(doc.data || {}),
                fwb_raw: payload.fwb,
                fwb_generated_at: payload.fwb_generated_at,
                selected_fwb_version: payload.selected_fwb_version,
                fwb_versions: mergedVersions,
                fwb_warnings: warnings,
                fwb_tact_issues: tactIssues,
                fwb_errors: errors,
                has_tact_breach: hasTactBreach,
                fwb_validation: validation,
              },
            }
            : doc;

          const updateDocList = (list) =>
            (list || []).map((d) => (String(d.id) === String(updatedDoc?.id) ? updatedDoc : d));

          this.setState({
            doc: updatedDoc,
            docs: updateDocList(this.state.docs),
            data: updateDocList(this.state.data),
            fwbLines: lines,
            fwbRawText: payload.fwb || '',
            fwbVersions: mergedVersions,
            selectedFwbVersion: payload.selected_fwb_version,
            fwbWarnings: warnings,
            fwbTactIssues: tactIssues,
            fwbErrors: errors,
            hasTactBreach: hasTactBreach,
            fwbValidation: validation,
            lastGeneratedDate: formattedDate,
            fwbData: this.mapDocStreamToFwb(updatedDoc),
          });

          toast.success(`Version ${version} selected as main version`);
          return payload;
        }
      })
      .catch((err) => {
        console.error('Error selecting version:', err);
        const errMsg = err?.response?.data?.message || 'Failed to select version';
        toast.error(errMsg);
      });
  };

  handleFwbManualUpdated = ({ fwbMessage, guidelines, formData }) => {
    const lines = typeof fwbMessage === 'string' ? fwbMessage.split(/\r?\n/).filter(Boolean) : [];
    const validation = guidelines || null;
    const warnings = validation?.warnings || [];
    const tactIssues = validation?.tactIssues || [];
    const errors = validation?.errors || [];
    const hasTactBreach = validation?.hasTactBreach !== undefined ? Boolean(validation.hasTactBreach) : false;

    const updatedDoc = this.state.doc
      ? {
        ...this.state.doc,
        data: {
          ...(this.state.doc.data || {}),
          fwb_raw: fwbMessage,
          fwb_validation: validation,
          fwb_warnings: warnings,
          fwb_tact_issues: tactIssues,
          fwb_errors: errors,
          has_tact_breach: hasTactBreach,
        },
      }
      : this.state.doc;

    this.setState({
      doc: updatedDoc,
      fwbLines: lines,
      fwbRawText: fwbMessage,
      fwbWarnings: warnings,
      fwbTactIssues: tactIssues,
      fwbErrors: errors,
      hasTactBreach: hasTactBreach,
      fwbValidation: validation,
      fwbData: formData || this.state.fwbData,
    });
  };

  handleFwbRefined = (payload, targetDocId) => {
    if (!payload) return;
    const resolvedDocId = targetDocId || payload.docId || this.state.doc?.id;
    if (!resolvedDocId) return;

    const isViewingTarget = this.state.doc && String(this.state.doc.id) === String(resolvedDocId);
    let chat = payload.caba_ai_chat;
    if (!chat && (payload.userMsg || payload.aiMsg)) {
      const existing = (isViewingTarget ? this.state.doc?.data?.caba_ai_chat : null) || [];
      chat = [...existing];
      if (payload.userMsg) chat.push(payload.userMsg);
      if (payload.aiMsg) chat.push(payload.aiMsg);
    }

    if (chat) {
      const updateDocList = (list) =>
        (list || []).map((d) =>
          String(d.id) === String(resolvedDocId)
            ? {
              ...d,
              data: {
                ...(d.data || {}),
                caba_ai_chat: chat,
              },
            }
            : d
        );

      const nextDocs = updateDocList(this.state.docs);
      const nextData = updateDocList(this.state.data);

      if (isViewingTarget) {
        const updatedDoc = {
          ...this.state.doc,
          data: {
            ...(this.state.doc.data || {}),
            caba_ai_chat: chat,
          },
        };
        this.setState({
          doc: updatedDoc,
          docs: nextDocs,
          data: nextData,
        });
      } else {
        this.setState({
          docs: nextDocs,
          data: nextData,
        });
      }
    }
  };

  handleRejectDiff = (messageId, targetDocId) => {
    const resolvedDocId = targetDocId || this.state.doc?.id;
    if (!resolvedDocId) return;

    const isViewingTarget = this.state.doc && String(this.state.doc.id) === String(resolvedDocId);
    const targetDoc = isViewingTarget
      ? this.state.doc
      : (this.state.data || []).find((d) => String(d.id) === String(resolvedDocId)) ||
        (this.state.docs || []).find((d) => String(d.id) === String(resolvedDocId));

    if (targetDoc) {
      const existingChat = Array.isArray(targetDoc.data?.caba_ai_chat) ? [...targetDoc.data.caba_ai_chat] : [];
      const updatedChat = existingChat.map((m) =>
        String(m.id) === String(messageId)
          ? {
            ...m,
            diffStatus: 'rejected',
          }
          : m
      );

      const updateDocList = (list) =>
        (list || []).map((d) =>
          String(d.id) === String(resolvedDocId)
            ? {
              ...d,
              data: {
                ...(d.data || {}),
                caba_ai_chat: updatedChat,
              },
            }
            : d
        );

      const nextDocs = updateDocList(this.state.docs);
      const nextData = updateDocList(this.state.data);

      if (isViewingTarget) {
        const updatedDoc = {
          ...this.state.doc,
          data: {
            ...(this.state.doc.data || {}),
            caba_ai_chat: updatedChat,
          },
        };
        this.setState({
          doc: updatedDoc,
          docs: nextDocs,
          data: nextData,
        });
      } else {
        this.setState({
          docs: nextDocs,
          data: nextData,
        });
      }
    }
  };

  fetchDocData = () => {
    const docId = this.props.match?.params?.id;
    const searchParams = new URLSearchParams(this.props.location?.search || '');
    const id = docId || searchParams.get('docId') || searchParams.get('id') || this.props.location?.state?.docId;

    if (id) {
      if (this.props.location?.state?.doc && (!this.state.doc || this.state.doc.id === id)) {
        this.processDocData(this.props.location.state.doc);
      }
      http
        .get(`/document/${id}?id=${id}`)
        .then((res) => {
          const doc = Array.isArray(res?.data?.data) ? res.data.data[0] : res?.data?.data;
          if (doc) {
            this.processDocData(doc);
          }
        })
        .catch((err) => {
          console.error('Failed to fetch document by ID', err);
        });
    } else if (this.props.location?.state?.doc) {
      this.processDocData(this.props.location.state.doc);
    } else {
      this.setState({
        doc: null,
        fwbData: null,
        fwbLines: [],
        fwbRawText: '',
        fwbGenerated: false,
        isFwbLoading: false,
      });
    }
  };

  handleViewChange = (e) => {
    this.setState({ activeView: e.target.value });
  };

  render() {
    const { activeView, doc, fwbData } = this.state;
    const viewerDocData = doc
      ? [doc]
      : fwbData?.awbSrc
        ? [{ src: fwbData.awbSrc }]
        : [];
    const documentListPanel = (
      <DocStreamsList
        changeAwb={this.handleChange}
        searchOptions={this.state.searchOptions}
        docs={this.state.data}
        selectDoc={this.selectDoc}
        docId={this.state.docId}
        search={this.fetchDocs}
        deleteDoc={this.deleteDoc}
        handleOpen={this.handleOpen}
        handlePopover={this.handlePopover}
        handlePopoverClose={this.handlePopoverClose}
        anchorEl={this.state.anchorEl}
        attachment={this.state.attachment}
        modal={this.state.modal}
        modalData={this.state.docFields}
        modalDataErrors={this.state.docErrors}
        onClose={this.onClose}
        handleToggle={this.handleToggle}
        value={this.state.value}
        handleEditDoc={this.handleEditDoc}
        closeEditDoc={this.closeEditDoc}
        isEditable={this.state.isEditable}
        onUpdateReq={this.onUpdateReq}
        onChange={this.onChangeDoc}
        handleDelete={this.handleDelete}
        handleReminder={this.handleReminder}
        stackDocs={this.state.stackDocs}
        processingDoc={this.state.processingDoc}
        hideDocStack={true}
      />
    );
    const documentViewerPanel = (
      <DocViewer
        title='AWB Viewer'
        docData={viewerDocData}
      />
    );
    const fwbDataPanel = (
      <FwbData
        data={fwbData}
        docId={this.state.doc?.id || fwbData?.docId}
        cabaAiChat={this.state.doc?.data?.caba_ai_chat || fwbData?.caba_ai_chat || []}
        airlines={this.state.airlines}
        stations={this.state.stations}
        activeView={activeView}
        onViewChange={this.handleViewChange}
        fwbLines={this.state.fwbLines}
        fwbRawText={this.state.fwbRawText}
        fwbVersions={this.state.fwbVersions}
        selectedFwbVersion={this.state.selectedFwbVersion}
        warnings={this.state.fwbWarnings}
        tactIssues={this.state.fwbTactIssues}
        errors={this.state.fwbErrors}
        hasTactBreach={this.state.hasTactBreach}
        validation={this.state.fwbValidation}
        isFwbLoading={this.state.isFwbLoading}
        isGeneratingFwb={this.state.isGeneratingFwb}
        fwbGenerated={this.state.fwbGenerated}
        lastGeneratedDate={this.state.lastGeneratedDate}
        onGenerateFwb={this.handleGenerateFwb}
        onFwbRefined={this.handleFwbRefined}
        onSaveFwb={this.handleSaveFwb}
        onRejectDiff={this.handleRejectDiff}
        onSelectFwbVersion={this.handleSelectFwbVersion}
        onFwbManualUpdated={this.handleFwbManualUpdated}
        onValidateFwb={this.handleValidateFwb}
        onOpenDocumentViewer={this.state.isCompactLayout ? this.openDocumentViewer : undefined}
      />
    );

    return (
      <div className={classes.container}>
        <>
          <div className={classes.workspaceActions}>
            <ToggleButtonGroup
              value={this.state.isGroupDocumentListHidden ? 'two' : 'three'}
              exclusive
              onChange={(event, layout) => {
                if (layout !== null) this.toggleDocumentList(layout === 'two');
              }}
              size='small'
              aria-label='Workspace layout'
              sx={{
                '& .MuiToggleButton-root': {
                  px: 1,
                  py: 0,
                },
              }}
            >
              <ToggleButton value='three' aria-label='Show AWB list' title='Show AWB list'>
                <img src={threeSectionIcon} alt='three section icon' width={20} height={20} />
              </ToggleButton>
              <ToggleButton value='two' aria-label='Hide AWB list' title='Hide AWB list'>
                <img src={twoSectionIcon} alt='two section icon' width={20} height={20} />
              </ToggleButton>
            </ToggleButtonGroup>
          </div>
          <Group
            id='doc-fwb-conditional-workspace'
            orientation={this.state.isCompactLayout ? 'vertical' : 'horizontal'}
            className={classes.resizableWorkspace}
          >
            {!this.state.isGroupDocumentListHidden && (
              <>
                <Panel
                  id='left'
                  className={classes.resizableWorkspaceCell}
                  defaultSize='23%' 
                >
                  <Box sx={{
                    overflowX: 'hidden',
                    height: '100%',
                    [`& .${docStyle.incomingDocH100}`]: {
                      width: '100%',
                      minWidth: 0,
                      overflowX: 'auto',
                      '& > *': { minWidth: '390px', },
                    },
                  }}>
                    {documentListPanel}
                  </Box>
                </Panel>
                <Separator className={classes.fwbPreviewSeparator} />
              </>
            )}
            {!this.state.isCompactLayout && (
              <>
                <Panel id='center' defaultSize='31%' minSize={0} className={classes.resizableWorkspaceCell}>
                  {documentViewerPanel}
                </Panel>
                <Separator className={classes.fwbPreviewSeparator} />
              </>
            )}
            <>
              <Panel id='right' defaultSize='46%' minSize={400} className={`${classes.resizableWorkspaceCell} ${classes.fwbDataCell}`}>
                {fwbDataPanel}
              </Panel>
            </>
          </Group>
        </>

        {this.state.isCompactLayout && (
          <Dialog
            aria-labelledby='doc-fwb-viewer-title'
            open={this.state.isDocumentViewerOpen}
            onClose={this.closeDocumentViewer}
            maxWidth='lg'
            fullWidth
          >
            <CustomDialogTitle id='doc-fwb-viewer-title'>
              <Stack direction='row' alignItems='center' justifyContent='space-between'>
                <span>Document Viewer</span>
                <CloseIconBtn onClick={this.closeDocumentViewer} />
              </Stack>
            </CustomDialogTitle>
            <CustomDialogContent
              className={classes.documentViewerDialogContent}
              sx={{
                [`& .${docStyle.viewDocBody}`]: {
                  flex: 1,
                  minHeight: 0,
                  maxHeight: 'none',
                },
              }}
            >
              {documentViewerPanel}
            </CustomDialogContent>
          </Dialog>
        )}

        <AddDocModal
          onClose={this.onClose}
          modal={this.state.modal}
          fields={this.state.docFields}
          errors={this.state.docErrors}
          onChange={this.onChangeDoc}
          onSubmit={this.onSubmitReq}
          onSubmitReq={this.onSubmitReq}
          fileType={this.state.fileType}
          addDocType={this.state.addDocType}
          attachTo={this.state.attachTo}
          onhandleChange={this.onhandleChange}
          onlyThirdParty={true}
        />
        <AwbModal
          onClose={this.onClose}
          modal={this.state.exModal}
          attachAwb={this.attachAwb}
        />
        <ConfirmModalContainer />
      </div>
    );
  }
}

export default connect(null, { setDelete: setDeleteAction })(DocFwb);
